import { Component, OnInit, ViewChild } from '@angular/core';
import { LookupService } from '../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../services/lookups/lookupadmin.service';
import { Location } from '../../../models/user.model';
import { SelectItem  } from 'primeng/api';
import { ProgramAreaDetailComponent } from './programarea-detail/programarea-detail.component';

@Component({
  selector: 'app-programarea',
  templateUrl: './programarea.component.html',
  styleUrls: ['./programarea.component.css']
})
export class ProgramAreaComponent implements OnInit {
  programareas: Location[];
  locationNames:SelectItem[];
  parentLocationNames:SelectItem[];
  isActiveList:SelectItem[];
  displayProgramAreaDetailDlg:boolean;
  @ViewChild(ProgramAreaDetailComponent) programAreaDetail: ProgramAreaDetailComponent;
  constructor(private lookupService: LookupService, private lookupAdminService: LookupAdminService) {}

  ngOnInit() {
    this.LoadAllProgramAreas();
    
  }

  private LoadAllProgramAreas() {
    this.lookupAdminService.getAllProgramAreas$().subscribe(data => {
      this.programareas = data;
      this.programareas.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
      this.locationNames = this.lookupAdminService.GetUniqueValues(this.programareas.map(p=>p.locationName));
      this.parentLocationNames = this.lookupAdminService.GetUniqueValues(this.programareas.map(p=>p.parentLocationName));
      var isActives = new Array<SelectItem>();
      isActives.push({ label: "Yes", value:true});
      isActives.push({ label: "No", value:false});
      this.isActiveList = isActives;
    });
  }
  
  ShowHideProgramAreaDetailDialog(isDisplay:boolean)
  {
    this.displayProgramAreaDetailDlg = isDisplay;
    //TODO: Add behaviour subject in the services to manage refresh of the table.
    //this.LoadAllPosts();
    
  }
  showProgramAreaDetailDialog(location:any)
  {
     this.programAreaDetail.showProgramAreaDetailDialog(location);
    this.ShowHideProgramAreaDetailDialog(true);
  }
  RefreshDataSource(isReload:boolean)
  {
    if(isReload)
     this.LoadAllProgramAreas();
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/programarea/programarea.component.ts